import { render, staticRenderFns } from "./WowView.vue?vue&type=template&id=1c0a3980&scoped=true"
import script from "./WowView.vue?vue&type=script&lang=js"
export * from "./WowView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0a3980",
  null
  
)

export default component.exports